export const TABLE_UPDATE = "PAYMENT_SELLER/TABLE_UPDATE";
export const FETCH_SUCCESS = "PAYMENT_SELLER/FETCH_SUCCESS";

const types = {
    FETCH_FAILED: "PAYMENT_SELLER/FETCH_FAILED",
    FETCH_REQUEST: "PAYMENT_SELLER/FETCH_REQUEST",
    FETCH_SUCCESS,

    FETCH_ALL_FAILED: "PAYMENT_SELLER/FETCH_ALL_FAILED",
    FETCH_ALL_REQUEST: "PAYMENT_SELLER/FETCH_ALL_REQUEST",
    FETCH_ALL_SUCCESS: "PAYMENT_SELLER/FETCH_ALL_SUCCESS",

    GET_FAILED: "PAYMENT_SELLER/GET_FAILED",
    GET_REQUEST: "PAYMENT_SELLER/GET_REQUEST",
    GET_SUCCESS: "PAYMENT_SELLER/GET_SUCCESS",

    PATCH_FAILED: "PAYMENT_SELLER/PATCH_FAILED",
    PATCH_REQUEST: "PAYMENT_SELLER/PATCH_REQUEST",
    PATCH_SUCCESS: "PAYMENT_SELLER/PATCH_SUCCESS",

    SYNC_FAILED: "PAYMENT_SELLER/SYNC_FAILED",
    SYNC_REQUEST: "PAYMENT_SELLER/SYNC_REQUEST",
    SYNC_SUCCESS: "PAYMENT_SELLER/SYNC_SUCCESS",

    UPDATE_FAILED: "PAYMENT_SELLER/UPDATE_FAILED",
    UPDATE_REQUEST: "PAYMENT_SELLER/UPDATE_REQUEST",
    UPDATE_SUCCESS: "PAYMENT_SELLER/UPDATE_SUCCESS",

    TABLE_UPDATE,
};

export default types;
